<template>
  <div>
    <!-- Header Filter & Suchen -->
    <div class="bg-custom-blue">
      <div class="container">
        <div class="row py-2">
          <div class="form-check form-switch mx-4 py-2 col-3">
            <input v-model="switchConversion" type="checkbox" role="switch" id="switchConversion" class="form-check-input">
            <label class="switchConversion" for="switchConversion">{{ $t("views.my.tasks.switchConversion") }}</label>
          </div>
          <div class="col-3 ms-auto">
            <input v-model="filterName" type="text" class="form-control form-control-sm" :placeholder='$t("general.placeholderSearch")'>
          </div>
        </div>
      </div>
    </div>

    <!-- Datensätze verfügbar -->
    <div v-if="filteredTasks.length" class="container my-3">
      <!-- Title & Infobutton-->
      <div class="row">
        <div class="col-12">
          <div class="h4">
            {{ $t("views.my.tasks.headingTitle") }}
            ({{this.$store.state.user.lastName}}, {{this.$store.state.user.firstName}})
          </div>
        </div>
      </div>

      <div class="bg-white rounded-2 p-2 mt-4">
      <div class="row">
        <div class="col-12">
          <div class="">
            <!-- Spaltenüberschriften -->
            <div class="row fw-bold px-3 border-bottom py-2">
              <div class="col-4 px-1">
                {{ $t("views.my.tasks.measureTitle") }}
              </div>
              <div class="col-2 px-1">
                {{ $t("views.my.tasks.measureConversion") }}
              </div>
              <div class="col-1 text-start px-1">
                {{ $t("views.my.tasks.measureValidFrom") }}
              </div>
              <div class="col-1 text-start px-1">
                {{ $t("views.my.tasks.measureValidTo") }}
              </div>
              <div class="col-4 text-start px-5">
                {{ $t("views.my.tasks.measureRelatedObject") }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <!-- Spalteninhalte-->
           <div v-for="task in filteredTasks" :key="task.id" class="row px-3 border-bottom">
              <div v-tooltip.bottom="{ key: 'tooltip.preview', params: { html: task.measure } }" class="col-4 my-auto col-measure-name px-1 py-2">
                {{ task.title }}
              </div>
              <div class="col-2 my-auto px-1">
                <div class="progress position-relative border bg-dark border-dark w-50">
                  <span class="progress-label position-absolute start-50 top-50 text-light fw-bold">{{ 25 * task.conversion }}%</span>
                  <div class="progress-bar progress-bar-striped bg-primary" :style="'width: ' + (25 * task.conversion) + '%'" role="progressbar" :aria-valuenow="(25 * task.conversion)" aria-valuemin="0" aria-valuemax="100"></div>
                </div>
              </div>
              <div class="col-1 text-start px-1 py-2">
                {{ formatDate(new Date(task.validFrom)) }}
              </div>
              <div class="col-1 text-start px-1 py-2" :class="new Date(task.validTo) < new Date() ? 'text-danger' : 'text-dark'">
                {{ formatDate(new Date(task.validTo)) }}
              </div>
              <!-- verbundene Objekte -->
              <div class="col-4 text-start px-5 py-2">
                <div v-if="task.type === 'objective'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconObjective'"> <use xlink:href="@/assets/icons/icons.svg#objective" /> </svg> &nbsp;
                  <a :href="createLink('objective', task.objectiveUuid)" target="_blank"> {{ task.category === 1 ? task.name.toUpperCase() : task.name }} </a>
                </div>
                <div v-if="task.type === 'project'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconProject'"> <use xlink:href="@/assets/icons/icons.svg#project" /> </svg> &nbsp;
                  <a :href="createLink('project', task.projectUuid)" target="_blank"> {{ task.name }} </a>
                </div>
                <div v-if="task.type === 'strategy'" >
                  <svg class="bi" width="16" height="16" fill="currentColor" v-tooltip="'tooltip.iconStrategy'"> <use xlink:href="@/assets/icons/icons.svg#strategy" /> </svg> &nbsp;
                  <a :href="createLink('strategy', task.strategyUuid)" target="_blank"> {{ task.name }} </a>
                </div>
              </div>
          </div>
        </div>
      </div>

      </div>
    </div>
    <!-- Fehlermeldung "No Data"          -->
    <div v-else-if="!loadingStatus" class="text-center mt-5">
      <img src="@/assets/img/no_data.svg" class="img-fluid" width="250">
      <p class="h5 mt-3">{{ $t("views.my.tasks.noTasks") }}.</p>
    </div>
  </div>
</template>

<script>
import * as formatUtils from '../../composables/formatUtils'

export default {
  name: 'MyTasks',
  data () {
    return {
      filterName: '',
      switchConversion: true
    }
  },
  computed: {
    myTasksArray () {
      return this.$store.state.myTasks.tasks
    },
    filteredTasks () {
      let n = '4'
      if (this.switchConversion) n = this.switchConversion.checked ? '4' : '3'
      if (this.myTasksArray) {
        return this.myTasksArray.filter(task => {
          return task.title.toLowerCase().includes(this.filterName.toLowerCase()) && task.conversion <= n
        })
      } else {
        return []
      }
    },
    loadingStatus () {
      return this.$store.state.loadingStatus
    },
    actualYear () {
      const actualYear = new Date().getFullYear()
      return actualYear
    }
  },
  methods: {
    async getMyTasks () {
      this.$store.commit('SET_LOADING_STATUS', true)
      await this.$store.dispatch('getMyTasks', this.selectedEmployee)
      this.$store.commit('SET_LOADING_STATUS', false)
    },
    createLink (type, uuid) {
      let url = ''
      if (type === 'objective') url = '/objectives/manage/objectives?id=' + uuid
      if (type === 'project') url = '/projects/manage/projects?id=' + uuid
      if (type === 'kpi') url = '/monitoring/manage/kpis?id=' + uuid
      if (type === 'strategy') url = '/strategies/manage/strategies?id=' + uuid
      return url
    },
    formatPeriod (period) {
      return formatUtils.formatPeriod(period)
    },
    formatDate (date) {
      const userLocale = this.$store.state.user.settings?.language
      return formatUtils.formatDate(userLocale, date)
    }
  },
  async created () {
    this.$store.commit('SET_LOADING_STATUS', true)
    await this.$store.dispatch('getMyTasks', this.$store.state.user)
    this.$store.commit('SET_LOADING_STATUS', false)
  }
}
</script>

<style scoped>
.container {
  max-width: 1600px;
}
.col-Measure-name {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.select-th {
  background-color: transparent;
  border: 0;
  font-weight: bold;
}
</style>
<style lang="scss" scoped>
.progress-label {
  transform: translate(-50%, -50%);
}
.tab-content .progress {
  margin-top: 6px;
}
</style>
